import { useState } from "react";

export default function Admin() {

const [content, setContent] = useState("");

async function saveContent() {

try {

await fetch(
"/api/updateContent.php",
{
method: "POST",

headers: {
"Content-Type": "application/json"
},

body: JSON.stringify({
content
})
}
);

alert("Content Updated");

}
catch{

alert("Update Failed");

}

}

return (

<div className="min-h-screen bg-gray-50 p-10">

<div className="max-w-4xl mx-auto bg-white rounded-3xl shadow-xl p-10">

<h1 className="text-4xl font-bold mb-8">

ESN Admin Panel

</h1>

<label className="block mb-3">

About Section Content

</label>

<textarea

rows={12}

className="
w-full
border
rounded-xl
p-5
outline-none
"

value={content}

onChange={
(e)=>
setContent(
e.target.value
)
}

/>

<button

onClick={saveContent}

className="
mt-6
bg-orange-500
text-white
px-8
py-3
rounded-xl
"

>

Save Changes

</button>

</div>

</div>

);

}